import React from 'react';
import { PNCounterIcon } from '@mummssoftware/global-context/PNCounter';
import { ENTITY_PATIENT_MEASURE } from '@mummssoftware/global-context/PNCounter/constants';

export const NoteCountCellRenderer = (props: any) => (
  /* eslint camelcase: ["error", {allow: ["role_group_name"]}] */
  <PNCounterIcon
    patientNumber={props.data?.patient?.patientNumber}
    entityKey={props?.data?.id?.toString()}
    entityName={props?.data?.shortname}
    entityType={ENTITY_PATIENT_MEASURE}
  />
);
